// import { useState } from "react"
// import Select from "react-select"
// import { Button } from "react-bootstrap"
// import Swal from "sweetalert2"
// import logo from "../../../../../assets/images/logo.png";

// const marriageOptions = [
//   { value: 1, label: "1 Marriage" },
//   { value: 2, label: "2 Marriages" },
//   { value: 3, label: "3 Marriages" },
//   { value: 4, label: "4 Marriages" },
//   { value: 5, label: "5 Marriages" },
// ]

// const pregnancyOptions = [
//   { value: "Delivered", label: "Delivered" },
//   { value: "Abortion", label: "Abortion" },
//   { value: "Miscarriage", label: "Miscarriage" },
// ]

// const medicationOptions = [
//   { value: "None", label: "None" },
//   { value: "Ayurvedic", label: "Ayurvedic" },
//   { value: "Allopathic", label: "Allopathic" },
//   { value: "Hormonal", label: "Hormonal" },
// ]

// const staticMarriageHistoryOptions = [
//   { value: 1, label: "1st" },
//   { value: 2, label: "2nd" },
//   { value: 3, label: "3rd" },
//   { value: 4, label: "4th" },
//   { value: 5, label: "5th" },
// ];

// const createEmptyPregnancy = () => ({
//   pregnancy_status: "",
//   medication: "",
//   delivery_date: "",
//   abortion_date: "",
//   which_rx_helped: "",
//   how_was_the_delivery: "",
//   gender: "",
//   how_did_miscarriage_happen: "",
//   miscarriage_reason: "",
// });

// const createEmptyForm = (marriageNo) => ({
//   marriage_no: marriageNo,
//   marriage_info_id: "",
//   pregnancy_count: 0,
//   pregnancies: [],
// });

// const PublicGapldForm = () => {
//   const [marriageCount, setMarriageCount] = useState(1)
//   const [forms, setForms] = useState([createEmptyForm(1)])
//   const [loading, setLoading] = useState(false)

//   const updateForm = (index, field, value) => {
//     const updated = [...forms]
//     updated[index][field] = value
//     setForms(updated)
//   }

//   const handleMarriageChange = (selected) => {
//     const count = selected.value
//     setMarriageCount(count)

//     const newForms = Array.from({ length: count }, (_, i) =>
//       createEmptyForm(i + 1)
//     )

//     setForms(newForms)
//   }

//   const handleSubmit = async () => {
//     setLoading(true)

//     try {
//       console.log("PUBLIC GAPLD DATA 👉", forms)

//       // 🔹 API CALL HERE
//       // await axios.post("/api/public-gapld", { entries: forms })

//       Swal.fire({
//         icon: "success",
//         title: "Submitted",
//         text: "GAPLD details submitted successfully",
//       })
//     } catch (err) {
//       Swal.fire("Error", "Something went wrong", "error")
//     } finally {
//       setLoading(false)
//     }
//   }
//   const handlePregnancyChange = (index, value) => {
//     const updated = [...forms]

//     updated[index] = {
//       ...updated[index],
//       pregnancy_status: value,
//       delivery_date: "",
//       abortion_date: "",
//       which_rx_helped: "",
//       how_was_the_delivery: "",
//       gender: "",
//       how_did_miscarriage_happen: "",
//       miscarriage_reason: "",
//     }

//     setForms(updated)
//   }

//   return (
//     <div className="container py-4">
//       <div className="text-center mb-4">
//         <img src={logo} alt="Logo" style={{ width: "250px", height: "auto" }} />
//       </div>

//       {/* <div className="col-md-8 col-lg-6"> */}
//       <div className="card shadow-sm">
//         <div className="card-body">
//           <h4 className="mb-3">GAPLD Details (Public Form)</h4>

//           {/* Marriage Count */}
//           <div className="mb-4">
//             <label className="fw-bold mb-2">
//               How many times married? <span style={{ color: "red" }}>*</span>
//             </label>
//             <Select
//               options={marriageOptions}
//               value={marriageOptions.find((o) => o.value === marriageCount)}
//               onChange={handleMarriageChange}
//             />
//           </div>

//           <div className="mb-3">
//             <label className="fw-bold">
//               किती वेळा गर्भधारणा झाली? <span style={{ color: "red" }}>*</span>
//             </label>

//             <Select
//               options={[
//                 { value: 0, label: "0" },
//                 { value: 1, label: "1" },
//                 { value: 2, label: "2" },
//                 { value: 3, label: "3" },
//                 { value: 4, label: "4" },
//               ]}
//               value={{
//                 value: form.pregnancy_count,
//                 label: form.pregnancy_count,
//               }}
//               onChange={(opt) => {
//                 const updated = [...forms]
//                 updated[index].pregnancy_count = opt.value
//                 updated[index].pregnancies = Array.from(
//                   { length: opt.value },
//                   () => createEmptyPregnancy()
//                 )
//                 setForms(updated)
//               }}
//             />
//           </div>


//           {/* Dynamic GAPLD Forms */}
//           {forms.map((form, index) => (
//             <div key={index} className="card mb-4 border">
//               <div className="card-header fw-bold">
//                 Marriage {index + 1}
//               </div>

//               <div className="card-body">
//                 {/* Pregnancy Status */}
//                 <div className="mb-3">
//                   <label>Pregnancy Status <span style={{ color: "red" }}>*</span>
//                   </label>
//                   <Select
//                     options={pregnancyOptions}
//                     value={
//                       form.pregnancy_status
//                         ? pregnancyOptions.find(
//                           (o) => o.value === form.pregnancy_status
//                         )
//                         : null
//                     }
//                     onChange={(opt) =>
//                       handlePregnancyChange(index, opt?.value)
//                     }
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="form-label">
//                     Marriage History <span style={{ color: "red" }}>*</span>
//                   </label>
//                   <Select
//                     options={staticMarriageHistoryOptions}
//                     value={staticMarriageHistoryOptions.find(
//                       (opt) => opt.value === form.marriage_info_id
//                     )}
//                   // isDisabled={true}   // 🔒 STATIC
//                   />
//                 </div>

//                 {/* Medication */}
//                 <div className="mb-3">
//                   <label>Medication</label>
//                   <Select
//                     options={medicationOptions}
//                     value={
//                       form.medication
//                         ? medicationOptions.find(
//                           (o) => o.value === form.medication
//                         )
//                         : null
//                     }
//                     onChange={(opt) =>
//                       updateForm(index, "medication", opt?.value)
//                     }
//                   />
//                 </div>

//                 {/* Delivered */}
//                 {form.pregnancy_status === "Delivered" && (
//                   <>
//                     <div className="mb-3">
//                       <label className="form-label">Delivery Date<span style={{ color: "red" }}>*</span></label>

//                       <input
//                         type="month"
//                         className="form-control mb-2"
//                         value={form.delivery_date}
//                         onChange={(e) =>
//                           updateForm(index, "delivery_date", e.target.value)
//                         }
//                       />
//                     </div>
//                     <div className="mb-3">
//                       <label className="form-label">How was the delivery?</label>
//                       <input
//                         className="form-control mb-2"
//                         placeholder="How was the delivery?"
//                         value={form.how_was_the_delivery}
//                         onChange={(e) =>
//                           updateForm(index, "how_was_the_delivery", e.target.value)
//                         }
//                       />
//                     </div>

//                     <div className="mb-3">
//                       <label htmlFor="which_rx_helped">
//                         Which RX helped to maintain pregnancy?
//                       </label>
//                       <input
//                         id="which_rx_helped"
//                         type="text"
//                         className="form-control"
//                         name="which_rx_helped"
//                         onChange={(e) =>
//                           updateForm(index, "which_rx_helped", e.target.value)
//                         }
//                         placeholder="Enter RX"
//                       />
//                     </div>

//                     <div className="mb-3">
//                       <label htmlFor="gender">Gender</label>
//                       <select
//                         className="form-control"
//                         value={form.gender}
//                         onChange={(e) =>
//                           updateForm(index, "gender", e.target.value)
//                         }
//                       >
//                         <option value="">Select Gender</option>
//                         <option>Male</option>
//                         <option>Female</option>
//                         <option>Transgender</option>
//                       </select>
//                     </div>
//                   </>
//                 )}

//                 {/* Abortion / Miscarriage */}
//                 {form.pregnancy_status === "Abortion" && (
//                   <>
//                     <div className="mb-3">
//                       <label className="form-label">
//                         Abortion Date <span style={{ color: "red" }}>*</span>
//                       </label>
//                       <input
//                         type="month"
//                         className="form-control"
//                         value={form.abortion_date}
//                         max={new Date().toISOString().slice(0, 7)}
//                         onChange={(e) =>
//                           updateForm(index, "abortion_date", e.target.value)
//                         }
//                       />
//                     </div>

//                     <div className="mb-3">
//                       <label className="form-label">
//                         Which RX helped to maintain pregnancy?
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={form.which_rx_helped}
//                         onChange={(e) =>
//                           updateForm(index, "which_rx_helped", e.target.value)
//                         }
//                         placeholder="Enter treatment"
//                       />
//                     </div>
//                   </>
//                 )}
//                 {form.pregnancy_status === "Miscarriage" && (
//                   <>
//                     <div className="mb-3">
//                       <label className="form-label">
//                         Miscarriage Date <span style={{ color: "red" }}>*</span>
//                       </label>
//                       <input
//                         type="month"
//                         className="form-control"
//                         value={form.abortion_date}
//                         max={new Date().toISOString().slice(0, 7)}
//                         onChange={(e) =>
//                           updateForm(index, "abortion_date", e.target.value)
//                         }
//                       />
//                     </div>

//                     <div className="mb-3">
//                       <label className="form-label">
//                         Which RX helped to maintain pregnancy?
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={form.which_rx_helped}
//                         onChange={(e) =>
//                           updateForm(index, "which_rx_helped", e.target.value)
//                         }
//                         placeholder="Enter treatment"
//                       />
//                     </div>

//                     <div className="mb-3">
//                       <label className="form-label">
//                         How did the miscarriage happen?
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={form.how_did_miscarriage_happen}
//                         onChange={(e) =>
//                           updateForm(index, "how_did_miscarriage_happen", e.target.value)
//                         }
//                         placeholder="Enter details"
//                       />
//                     </div>

//                     <div className="mb-3">
//                       <label className="form-label">Miscarriage Reason</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={form.miscarriage_reason}
//                         onChange={(e) =>
//                           updateForm(index, "miscarriage_reason", e.target.value)
//                         }
//                         placeholder="Enter reason"
//                       />
//                     </div>
//                   </>
//                 )}

//               </div>
//             </div>
//           ))}

//           <Button disabled={loading} onClick={handleSubmit}>
//             {loading ? "Submitting..." : "Submit GAPLD"}
//           </Button>
//         </div>
//       </div>
//       {/* </div> */}
//     </div>
//   )
// }

// export default PublicGapldForm


import { useState } from "react"
import Select from "react-select"
import { Button } from "react-bootstrap"
import Swal from "sweetalert2"
import logo from "../../../../../assets/images/logo.png";

/* ---------------- OPTIONS ---------------- */

const marriageOptions = [
  { value: 1, label: "1 Marriage" },
  { value: 2, label: "2 Marriages" },
  { value: 3, label: "3 Marriages" },
  { value: 4, label: "4 Marriages" },
  { value: 5, label: "5 Marriages" },
]

const pregnancyOptions = [
  { value: "Delivered", label: "Delivered" },
  { value: "Abortion", label: "Abortion" },
  { value: "Miscarriage", label: "Miscarriage" },
]

const medicationOptions = [
  { value: "None", label: "None" },
  { value: "Ayurvedic", label: "Ayurvedic" },
  { value: "Allopathic", label: "Allopathic" },
  { value: "Hormonal", label: "Hormonal" },
]

const staticMarriageHistoryOptions = [
  { value: 1, label: "1st" },
  { value: 2, label: "2nd" },
  { value: 3, label: "3rd" },
  { value: 4, label: "4th" },
  { value: 5, label: "5th" },
]
const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Transgender", label: "Transgender" },
]


/* ---------------- FACTORIES ---------------- */

const createEmptyPregnancy = () => ({
  pregnancy_status: "",
  medication: "",
  delivery_date: "",
  abortion_date: "",
  which_rx_helped: "",
  how_was_the_delivery: "",
  gender: "",
  how_did_miscarriage_happen: "",
  miscarriage_reason: "",
  child_born_alive: "",
})

const createEmptyMarriage = (no) => ({
  marriage_no: no,
  marriage_info_id: no,
  pregnancy_count: 0,
  pregnancies: [],
})

/* ---------------- COMPONENT ---------------- */

const PublicGapldForm = () => {
  const [marriageCount, setMarriageCount] = useState(1)
  const [forms, setForms] = useState([createEmptyMarriage(1)])
  const [loading, setLoading] = useState(false)

  /* ---------- HANDLERS ---------- */

  const handleMarriageChange = (selected) => {
    const count = selected.value
    setMarriageCount(count)

    setForms(
      Array.from({ length: count }, (_, i) =>
        createEmptyMarriage(i + 1)
      )
    )
  }

  const handlePregnancyCountChange = (mIndex, count) => {
    const updated = [...forms]
    updated[mIndex].pregnancy_count = count
    updated[mIndex].pregnancies = Array.from(
      { length: count },
      () => createEmptyPregnancy()
    )
    setForms(updated)
  }

  const updatePregnancy = (mIndex, pIndex, field, value) => {
    const updated = [...forms]
    updated[mIndex].pregnancies[pIndex][field] = value
    setForms(updated)
  }

  const handlePregnancyStatusChange = (mIndex, pIndex, value) => {
    const updated = [...forms]
    updated[mIndex].pregnancies[pIndex] = {
      ...createEmptyPregnancy(),
      pregnancy_status: value,
    }
    setForms(updated)
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      console.log("FINAL GAPLD PAYLOAD 👉", forms)

      Swal.fire({
        icon: "success",
        title: "Submitted",
        text: "GAPLD details submitted successfully",
      })
    } catch {
      Swal.fire("Error", "Something went wrong", "error")
    } finally {
      setLoading(false)
    }
  }

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "52px",
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    input: (base) => ({
      ...base,
      margin: "0px",
      fontSize: "14px",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "14px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "14px",
    }),
  };
  /* ---------------- UI ---------------- */

  return (
    <div className="container-fluid py-4">
      <div className="text-center mb-4">
        <img src={logo} alt="Logo" style={{ width: "250px" }} />
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="mb-3">GAPLD Details (Public Form)</h4>

          {/* Marriage Count */}
          <div className="mb-4">
            <label className="fw-bold">
              How many times married? <span className="text-danger">*</span>
            </label>
            <Select
              options={marriageOptions}
              value={marriageOptions.find(o => o.value === marriageCount)}
              onChange={handleMarriageChange}
            />
          </div>

          {/* MARRIAGES */}
          <div className="row">
            {forms.map((form, mIndex) => (
              <div key={mIndex} className="col-lg-4 col-md-6 col-sm-12 mb-3">
                <div className="card h-100 shadow-sm">
                  <div className="card-header fw-bold text-center">
                    Marriage {mIndex + 1}
                  </div>

                  <div className="card-body">

                    {/* Marriage History */}
                    <div className="mb-3">
                      <label className="fw-bold">Marriage History <span className="text-danger">*</span></label>
                      <Select
                        options={staticMarriageHistoryOptions}
                        value={staticMarriageHistoryOptions.find(
                          o => o.value === form.marriage_info_id
                        )}
                        isDisabled
                      />
                    </div>

                    {/* Pregnancy Count */}
                    <div className="mb-3">
                      <label className="fw-bold">
                        How many time you are pregnant?
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={[0, 1, 2, 3, 4].map(v => ({ value: v, label: v }))}
                        value={{ value: form.pregnancy_count, label: form.pregnancy_count }}
                        onChange={(opt) =>
                          handlePregnancyCountChange(mIndex, opt.value)
                        }
                      />
                    </div>

                    {/* PREGNANCIES */}
                    {form.pregnancies.map((preg, pIndex) => (
                      <div key={pIndex} className="border rounded p-2 mb-2 bg-light">
                        <h6 className="fw-bold">Pregnancy {pIndex + 1}</h6>

                        {/* Pregnancy Status */}
                        <div className="mb-3">
                          <label>Pregnancy Status <span className="text-danger">*</span></label>
                          <Select
                            options={pregnancyOptions}
                            value={
                              preg.pregnancy_status
                                ? pregnancyOptions.find(
                                  o => o.value === preg.pregnancy_status
                                )
                                : null
                            }
                            onChange={(opt) =>
                              handlePregnancyStatusChange(
                                mIndex,
                                pIndex,
                                opt.value
                              )
                            }
                          />
                        </div>

                        {/* Medication */}
                        <div className="mb-3">
                          <label>Medication</label>
                          <Select
                            options={medicationOptions}
                            value={
                              preg.medication
                                ? medicationOptions.find(
                                  o => o.value === preg.medication
                                )
                                : null
                            }
                            onChange={(opt) =>
                              updatePregnancy(
                                mIndex,
                                pIndex,
                                "medication",
                                opt.value
                              )
                            }
                          />
                        </div>

                        {/* Delivered */}
                        {preg.pregnancy_status === "Delivered" && (
                          <>
                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <label className="form-label">
                                  Delivery Date<span style={{ color: "red" }}>*</span>
                                </label>

                                <input
                                  type="month"
                                  className="form-control mb-2"
                                  value={preg.delivery_date}
                                  onChange={(e) =>
                                    updatePregnancy(mIndex, pIndex, "delivery_date", e.target.value)
                                  }
                                />
                              </div>

                              <div className="col-md-6 mb-2">
                                <label className="form-label">How was the delivery?</label>
                                <input
                                  className="form-control mb-2"
                                  placeholder="How was the delivery?"
                                  value={preg.how_was_the_delivery}
                                  onChange={(e) =>
                                    updatePregnancy(mIndex, pIndex, "how_was_the_delivery", e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <label>Was the child born alive?</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={preg.child_born_alive}
                                  onChange={(e) =>
                                    updatePregnancy(mIndex, pIndex, "child_born_alive", e.target.value)
                                  }
                                  placeholder=""
                                />
                              </div>
                              <div className="col-md-6 mb-2">
                                <label>Gender</label>
                                <Select
                                  options={genderOptions}
                                  placeholder="Select Gender"
                                  value={
                                    preg.gender
                                      ? genderOptions.find(o => o.value === preg.gender)
                                      : null
                                  }
                                  onChange={(opt) =>
                                    updatePregnancy(mIndex, pIndex, "gender", opt?.value || "")
                                  }
                                  isClearable
                                  styles={customStyles}
                                />
                              </div>

                            </div>
                            <div className="mb-3">
                              <label>Which RX helped to maintain pregnancy?</label>
                              <input
                                type="text"
                                className="form-control"
                                value={preg.which_rx_helped}
                                onChange={(e) =>
                                  updatePregnancy(mIndex, pIndex, "which_rx_helped", e.target.value)
                                }
                                placeholder="Enter RX"
                              />
                            </div>


                          </>
                        )}


                        {/* Abortion / Miscarriage */}
                        {preg.pregnancy_status === "Abortion" && (
                          <>
                            <div className="mb-3">
                              <label className="form-label">
                                Abortion Date <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="month"
                                className="form-control"
                                max={new Date().toISOString().slice(0, 7)}
                                value={preg.abortion_date}
                                onChange={(e) =>
                                  updatePregnancy(mIndex, pIndex, "abortion_date", e.target.value)
                                }
                              />
                            </div>

                            <div className="mb-3">
                              <label className="form-label">
                                Which RX helped to maintain pregnancy?
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={preg.which_rx_helped}
                                onChange={(e) =>
                                  updatePregnancy(mIndex, pIndex, "which_rx_helped", e.target.value)
                                }
                                placeholder="Enter treatment"
                              />
                            </div>
                          </>
                        )}
                        {preg.pregnancy_status === "Miscarriage" && (
                          <>
                            <div className="mb-3">
                              <label className="form-label">
                                Miscarriage Date <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="month"
                                className="form-control"
                                max={new Date().toISOString().slice(0, 7)}
                                value={preg.abortion_date}
                                onChange={(e) =>
                                  updatePregnancy(mIndex, pIndex, "abortion_date", e.target.value)
                                }
                              />
                            </div>

                            <div className="mb-3">
                              <label className="form-label">
                                Which RX helped to maintain pregnancy?
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={preg.which_rx_helped}
                                onChange={(e) =>
                                  updatePregnancy(mIndex, pIndex, "which_rx_helped", e.target.value)
                                }
                                placeholder="Enter treatment"
                              />
                            </div>

                            <div className="mb-3">
                              <label className="form-label">
                                How did the miscarriage happen?
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={preg.how_did_miscarriage_happen}
                                onChange={(e) =>
                                  updatePregnancy(
                                    mIndex,
                                    pIndex,
                                    "how_did_miscarriage_happen",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter details"
                              />
                            </div>

                            <div className="mb-3">
                              <label className="form-label">Miscarriage Reason</label>
                              <input
                                type="text"
                                className="form-control"
                                value={preg.miscarriage_reason}
                                onChange={(e) =>
                                  updatePregnancy(
                                    mIndex,
                                    pIndex,
                                    "miscarriage_reason",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter reason"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="position-sticky bottom-0 bg-white p-3 border-top text-end">
            <Button disabled={loading} onClick={handleSubmit}>
              {loading ? "Submitting..." : "Submit GAPLD"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PublicGapldForm
